import React from 'react';
import { ModalProviderStateType } from './types';

const ModalContext = React.createContext<ModalProviderStateType | undefined>(undefined);

export default ModalContext;
